module.exports = __webpack_public_path__ + "static/36-b279fc822b283354c9b44da6fe2e0107.jpg";